import { IRestService } from './IRestService';

export class ProductListingService {
    public constructor(private readonly restService: IRestService) {}

    public async getAll(): Promise<any[]> {
        return this.restService.get('admin/product-listings');
    }

    public async getById(id: string): Promise<any> {
        return this.restService.get(`admin/product-listings/${id}`);
    }

    public async create(payload: any): Promise<any> {
        return this.restService.post('admin/product-listings', payload);
    }

    public async update(id: string, payload: any): Promise<any> {
        return this.restService.put(`admin/product-listings/${id}`, payload);
    }

    public async delete(id: string): Promise<void> {
        return this.restService.delete(`admin/product-listings/${id}`);
    }

    public async uploadImage(listingId: string, file: File): Promise<any> {
        const formData = new FormData();
        formData.append('file', file);

        return this.restService.post(`admin/product-listings/${listingId}/upload-image`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }

    public async getCarts(): Promise<any[]> {
        return this.restService.get('admin/customer-carts');
    }

    public async getCart(id: string): Promise<any> {
        return this.restService.get(`admin/customer-carts/${id}`);
    }

    public async createCart(payload: any): Promise<any> {
        return this.restService.post('admin/customer-carts', payload);
    }

    public async updateCart(id: string, payload: any): Promise<any> {
        return this.restService.put(`admin/customer-carts/${id}`, payload);
    }

    public async deleteCart(id: string): Promise<void> {
        return this.restService.delete(`admin/customer-carts/${id}`);
    }
}
